import { Button, Card, CardActionArea, CardContent, CircularProgress, Grid, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import firebase from "firebase";
import { useHistory, useRouteMatch } from 'react-router-dom';






const EditHeader = (props)=>{

    const { path, url } = useRouteMatch();
    const history = useHistory();
    const obj = props.props
   return <Grid item 
        xs={12} 
        md={12}
      
   
   > 
    <CardActionArea component="p" onClick={()=>{ history.push(path+"/"+obj.url);}}>
      <Card >
        <div >
          <CardContent>
            <Typography component="h2" variant="h5">
             Uredi {obj.name}
            </Typography>
          
            <Typography variant="subtitle1" paragraph>
            {obj.desc}
            </Typography>
            <Typography variant="subtitle1" color="primary">
            Uredi
            </Typography>
          </CardContent>
        </div>

      </Card>
    </CardActionArea>
  </Grid>
}




function EditPage() {

  const [editHeaders, setEditHeaders] = useState(null)

  let db = firebase.database();


  useEffect(() => {

    if(editHeaders === null)
    {
     
      firebase.database().ref('EditPage/headers').once('value').then((promise)=>{   setEditHeaders(promise.val()) })
    }
    
  }, [editHeaders])






    return (

        <div>
            {
              editHeaders===null ? <CircularProgress /> : editHeaders.map((i,indx)=>{return <EditHeader  key={indx} props={i}/> })
            }
          

           
        </div>
    )
}

export default EditPage
